module.exports = [{"code":"+61","name":"Australia"},{"code":"+679","name":"Fiji"},{"code":"+64","name":"New Zealand"},{"code":"+675","name":"Papua New Guinea"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/tooltip/ngcompleter/phone.json
// module id = ./src/app/tooltip/ngcompleter/phone.json
// module chunks = main